/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-4
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {getFiltersUrl, loadAndDisplayFetchResult, refreshFilters, refreshSearch} from './search-common.js';
import {handlePaginationActions} from './search-pagination.js';

/**
 * Rafraichit le corps de la recherche.
 * @param event {Event} - L'événement.
 */
async function refreshSearchBody(event) {
    event.preventDefault();
    closePanel();
    await refreshSearch('search-body');
    handleMobileActions();
}

/**
 * Rafraîchit les filtres de recherche et ouvre le panneau de filtres.
 * @returns {Promise<void>} - La promesse
 */
async function refreshFiltersAndOpenPanel() {
    await refreshFilters();
    const filtersPanel = document.getElementById('filters-panel');
    if (filtersPanel) {
        filtersPanel.showPopover();
    }
    handleMobileActions();
}

/**
 * Rafraîchit les filtres de recherche lors de la fermeture du panneau de filtres.
 */
function handleRefreshFilters() {
    const refreshButtons = document.querySelectorAll('.js-search-aggregation-panel button[popoverTargetAction="hide"], .js-search-sort-panel button[popoverTargetAction="hide"]');
    refreshButtons.forEach((button) => {
        button.addEventListener('click', refreshFiltersAndOpenPanel);
    });
}

/**
 * Retire les filtres de recherche.
 */
async function removeMobileFilters() {
    const panels = document.querySelectorAll('.js-search-aggregation-panel, .js-search-sort-panel');
    panels.forEach(panel => {
        panel.querySelectorAll('input').forEach(input => {
            input.checked = false;
        });
    });
    await refreshFiltersAndOpenPanel();
}

/**
 * Gère le nettoyage des filtres de recherche sur desktop.
 */
function handleMobileCleanFilters() {
    const cleanFilters = document.querySelector('.js-search-mobile-clean-filters');
    if (cleanFilters) {
        cleanFilters.addEventListener('click', removeMobileFilters);
    }
}

/**
 * Réinitialise les filtres de recherche dans l'état avant modifications utilisateur.
 */
async function reinitFilters(e) {
    const url = new URL(location);
    const fetchUrl = new URL(`${getFiltersUrl()}?${url.searchParams}`, window.location);
    await loadAndDisplayFetchResult(fetchUrl, 'search-filters');
    handleMobileActions();
}

/**
 * Rafraîchit les filtres de recherche lors de la fermeture du panneau de filtres.
 */
function handleCloseFilters() {
    const closeButton = document.querySelector('#filters-panel button[popoverTargetAction="hide"]');
    if (closeButton) {
        closeButton.addEventListener('click', reinitFilters);
    }
}

/**
 * Rafraichit la recherche sur lors de l'appui sur le bouton de recherche sur desktop.
 */
function handleSearchButton(e) {
    const searchButton = document.querySelector('.js-search-send-form');
    if (searchButton) {
        searchButton.addEventListener('click', refreshSearchBody);
    }
}

function handleSearchInput(e) {
    const form = document.querySelector('.js-search-form');
    if (form) {
        form.addEventListener('submit', refreshSearchBody);
    }
}

/**
 * Cache les filtres de premier niveau quand on ouvre un sous-ensemble de filtres.
 */
function handleOpenPopover() {
    const filterPanel = document.getElementById('filters-panel');
    if (filterPanel) {
        const openers = filterPanel.querySelectorAll('.js-pop-item');
        openers.forEach((opener) => {
            opener.addEventListener('click', () => {
                filterPanel.hidePopover();
            });
        });
    }
}

export function closePanel() {
  document.querySelectorAll('.panel').forEach((panel) => panel.hidePopover());
}

/**
 * Gère les actions mobiles.
 */
export function handleMobileActions() {
    handleRefreshFilters();
    handleOpenPopover();
    handleCloseFilters();
    handleSearchButton();
    handleSearchInput();
    handleMobileCleanFilters();
    handlePaginationActions();
}

handleMobileActions();
